import * as React from 'react';

import Rive from '@rive-app/react-canvas';

import {colors} from 'shells/colors/colors';
import {Modal} from 'shells/modal/modal';
import {OnboardingPage} from 'shells/onboarding-page/onboarding-page';

import {HelpBodyClosedLeadFollowupAutomations} from './help-body-closed-lead-followup-automations';

type Props = {
    isOpen: boolean;
    onClose: () => void;
    primaryAction?: () => void;
    primaryButtonText?: string;
    secondaryAction?: () => void;
    secondaryButtonText?: string;
};

export function HelpClosedLeadFollowupAutomations(props: Props) {
    return (
        <Modal
            isOpen={props.isOpen}
            onClose={props.onClose}
            noPadding={true}
            closeButton={false}
            preventBodyScroll={false}
            maxHeight={500}
        >
            <OnboardingPage
                type='singlePage'
                bodyComponent={<HelpBodyClosedLeadFollowupAutomations />}
                artBackgroundColor={colors.blueXlt}
                artImage={
                    <div className='full-width full-height'>
                        <Rive src='/include/rive/lead-cloning.riv' />
                    </div>
                }
                onClose={props.onClose}
                primaryAction={props.primaryAction ? {onClick: props.primaryAction} : undefined}
                buttonText={props.primaryButtonText || 'Done'}
                actionButtonOnRight={true}
                secondaryAction={
                    props.secondaryAction && props.secondaryButtonText
                        ? {onClick: props.secondaryAction, buttonText: props.secondaryButtonText}
                        : undefined
                }
            />
        </Modal>
    );
}
